import { defineFurniture } from './types.js';

/** Singapore multicultural festival decor: CNY, Hari Raya, Deepavali and Christmas. */
export const FESTIVE_FURNITURE = {
  ...defineFurniture('festive', {
    cny_lantern_arch: {
      label: 'CNY Lantern Arch',
      description: 'Red and gold, strung with lanterns. Walk right under it.',
      price: 450,
      solid: false,
      height: 2.2,
    },
    pineapple_tart_stand: {
      label: 'Pineapple Tart Stand',
      description: 'Golden tarts stacked high for the new year.',
      price: 420,
      solid: true,
      height: 1,
    },
    hari_raya_lights: {
      label: 'Hari Raya Lights',
      description: 'A string of festive lights for the open house.',
      price: 220,
      solid: false,
      height: 2,
    },
    ketupat_decor: {
      label: 'Ketupat Decor',
      description: 'Woven rice dumplings, hung for the celebration.',
      price: 150,
      solid: false,
      height: 1.7,
    },
    deepavali_diyas: {
      label: 'Deepavali Diyas',
      description: 'A ring of oil lamps around a rangoli pattern.',
      price: 180,
      solid: false,
      height: 0.15,
      effect: { type: 'glow', color: '#ffb347', height: 6 },
    },
    christmas_tree: {
      label: 'Christmas Tree',
      description: 'Trimmed and twinkling in the corner of the kopitiam.',
      price: 500,
      solid: true,
      height: 2.6,
    },
    nian_gao_table: {
      label: 'Nian Gao Table',
      description: 'A sticky new year cake, ready to be sliced.',
      price: 380,
      solid: true,
      height: 0.95,
    },
    firecracker_string: {
      label: 'Firecracker String',
      description: "Hung up for luck. Doesn't actually go off.",
      price: 200,
      solid: false,
      height: 2.3,
    },
  }),
};
